import React from "react";
import TimeSlot from "./TimeSlot";
import { AvailableTimeSlot } from "../../features/sessions/time-slot/models/AvailableTimeSlot";
import {
  getDateAndDisplayTimeLabelInUserTimezone,
  formatTimeInUserTimezone,
} from "../../features/utils/timezoneUtils";
import DateDisplayCard from "../date-display-card/DateDisplayCard";

interface DayTimeSlotsProps {
  date: Date;
  timeSlots: AvailableTimeSlot[];
  /** How many slots to show for the day (the home card previews 6). */
  maxSlots?: number;
}

const DayTimeSlots: React.FC<DayTimeSlotsProps> = ({ date, timeSlots, maxSlots = 6 }) => {
  const dateLabelAndDisplayTime = getDateAndDisplayTimeLabelInUserTimezone(
    date.toISOString()
  );

  return (
    <div className="flex h-full gap-4 lg:gap-6">
      <DateDisplayCard
        dateLabel={dateLabelAndDisplayTime.label}
        dateDisplay={dateLabelAndDisplayTime.display}
      />
      <div className="grid w-full grid-cols-2 items-center gap-4 min-[420px]:grid-cols-[repeat(auto-fill,minmax(180px,1fr))]">
        {timeSlots.slice(0, maxSlots).map((slot) => {
          // Generate local time range from UTC dateStart and duration
          const startTime = formatTimeInUserTimezone(slot.dateStart);
          const endDate = new Date(
            new Date(slot.dateStart).getTime() + slot.duration * 60000
          );
          const endTime = formatTimeInUserTimezone(endDate.toISOString());
          const timeRange = `${startTime} - ${endTime}`;

          return (
            <TimeSlot
              key={slot.dateStart}
              time={timeRange}
              selectedDate={date}
              duration={slot.duration}
              disabled={false}
              isWeekly={slot.isWeekly}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DayTimeSlots;
